import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';

import {
  StyledTableCell,
  StyledTableHeaderCell,
  StyledTableRow,
} from '../../../../theme/CustomComponents';

interface QuestionsTableSkeletonProps {
  hasActions: boolean;
}

const QuestionsTableSkeleton: React.FC<QuestionsTableSkeletonProps> = ({ hasActions }) => (
  <TableContainer>
    <Table stickyHeader size="small" sx={{ border: '1px solid rgb(244, 244, 244)' }}>
      <TableHead>
        <TableRow sx={{ th: { borderBottom: '2px solid rgb(244, 244, 244)' } }}>
          <StyledTableHeaderCell colSpan={hasActions ? 1 : 2}>Question</StyledTableHeaderCell>
          {hasActions && <StyledTableHeaderCell width="120px">Actions</StyledTableHeaderCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: 5 }).map((_, index) => (
          <StyledTableRow key={index}>
            <StyledTableCell colSpan={hasActions ? 1 : 2}>
              <Skeleton variant="text" width="90%" height={30} />
            </StyledTableCell>
            {hasActions && (
              <StyledTableCell align="right">
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                  <Skeleton variant="circular" width={35} height={35} />
                  <Skeleton variant="circular" width={35} height={35} />
                </Box>
              </StyledTableCell>
            )}
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default QuestionsTableSkeleton;
